import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const CentreContext = createContext(null);
const STORAGE_KEY = "hp_centre_slug";

export function CentreProvider({ children }) {
  const [centres, setCentres] = useState([]);
  const [current, setCurrent] = useState(null);
  const [selectorOpen, setSelectorOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/centres").then(({ data }) => {
      setCentres(data);
      const saved = localStorage.getItem(STORAGE_KEY);
      const found = data.find((c) => c.slug === saved);
      if (found) setCurrent(found);
      else if (!new URLSearchParams(window.location.search).has("preview")) setSelectorOpen(true);
      setLoaded(true);
    });
  }, []);

  const selectCentre = (slug) => {
    const found = centres.find((c) => c.slug === slug);
    if (found) {
      setCurrent(found);
      localStorage.setItem(STORAGE_KEY, slug);
      setSelectorOpen(false);
    }
  };

  return (
    <CentreContext.Provider
      value={{ centres, current, loaded, selectorOpen, setSelectorOpen, selectCentre }}>
      {children}
    </CentreContext.Provider>
  );
}

export const useCentre = () => useContext(CentreContext);
